/**
 * 应用 （平台） 接入
 */
import { IdRequestParam, ResWrap, service } from '@/utils/request'
import { gameInModule } from '@/api'
import i18n from '@/locales'
import type { GroupSimpleInfo } from '@/server/customer_request'
const { t } = i18n.global as any

/**
 * MerchantListRequest
 */
export interface IGameListRequestParam {
  /**
   * 页数；例如：1
   */
  pageNo?: number
  pageNum?:number
  /**
   * 每页条数；例如：10
   */
  pageSize?: number

  /**
   * 商户(平台)名称
   */
  merchantName?: string

  /**
   * 商户Id
   */
  merchantId?: string

  /**
   * 商户Id
   */
  groupId?: string
}

export interface IGameListResponseParam {
  pageNo?: number
  pageSize?: number
  total?: number
  dataList?: Array<IGameListItem>
}

export interface IGameListItem {
  id?: string
  name?: string
  headerImgUrl?: string
  remark?: string
  createTime?: string
  updateTime?: string
  payMerchantId?: string
  appHost?: string
  appSecret?: string
  appSite?: string
  tenantId?: string
  isShowWindows?: Boolean
  groupList?: GroupSimpleInfo[]
}

/**
 * MerchantAddRequest
 */
export interface IMerchantAddRequestParam {
  /**
   * 头像
   */
  headerImgUrl?: string
  /**
   * 商户名称
   */
  name?: string
  /**
   * 备注
   */
  remark?: string

  payMerchantId?: string

  appHost?: string
  appSecret?: string
  appSite?: string
  timeZone?:number
  /*
   * 分组
   * */
  groupIdList?: string[]
  tenantId?: string
}

/**
 * MerchantEditRequest
 */
export interface IMerchantEditRequest {
  /**
   * 头像
   */
  headerImgUrl?: string
  /**
   * 商户ID
   */
  id?: number
  /**
   * 商户名称
   */
  name?: string
  /**
   * 备注
   */
  remark?: string
  payMerchantId?: string
  appHost?: string
  appSecret?: string
  appSite?: string
  isShowWindows?: string
  /*
   * 分组
   * */
  groupIdList?: string[]
  tenantId?: string
}

/**
 * void
 *
 * Response«MerchantResponse»
 */
export interface IGameDetailResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: MerchantResponse
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * 请求返回数据
 *
 * MerchantResponse
 */
export interface MerchantResponse {
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 头像
   */
  headerImgUrl?: string
  /**
   * 主键ID
   */
  id?: number
  /**
   * 商户名称
   */
  name?: string
  distributionLevelSwitch?: boolean
  distributionUserSwitch?: boolean
  /**
   * 备注
   */
  remark?: string
  /**
   * 更新时间
   */
  updateTime?: string
}

/**
 * void
 *
 * Response«List«MerchantDistLevelResponse»»
 */
export interface IMerchantDistLevelResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: MerchantDistLevelResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * MerchantDistLevelResponse
 */
export interface MerchantDistLevelResponse {
  /**
   * 客服等级
   */
  csLevel?: CSLevel
  /**
   * 用户等级
   */
  userLevelList?: UserLevelList[]
}

/**
 * 客服等级
 */
export enum CSLevel {
  Level10 = 'LEVEL_10',
  Level20 = 'LEVEL_20',
  Level30 = 'LEVEL_30'
}

export enum UserLevelList {
  Level0 = 'LEVEL_0',
  Level10 = 'LEVEL_10',
  Level20 = 'LEVEL_20',
  Level30 = 'LEVEL_30',
  Level40 = 'LEVEL_40',
  Level50 = 'LEVEL_50',
  Level60 = 'LEVEL_60',
  Level70 = 'LEVEL_70',
  Level80 = 'LEVEL_80',
  Level90 = 'LEVEL_90',
  Level100 = 'LEVEL_100',
  Level110 = 'LEVEL_110',
  Level120 = 'LEVEL_120',
  Level130 = 'LEVEL_130',
  Level140 = 'LEVEL_140',
  Level150 = 'LEVEL_150',
  Level160 = 'LEVEL_160',
  Level170 = 'LEVEL_170',
  Level180 = 'LEVEL_180',
  Level190 = 'LEVEL_190',
  Level200 = 'LEVEL_200'
}

export const UserLevelObj = {
  LEVEL_10: '黑铁',
  LEVEL_20: '青铜',
  LEVEL_30: '白银',
  LEVEL_40: '黄金',
  LEVEL_50: '铂金',
  LEVEL_60: '钻石',
  LEVEL_70: '大师',
  LEVEL_80: '宗师',
  LEVEL_90: '王者'
}

export const UserLevel2NameList = [
  {
    level: 'LEVEL_10',
    name: 'LV.1'
  },
  {
    level: 'LEVEL_20',
    name: 'LV.2'
  },
  {
    level: 'LEVEL_30',
    name: 'LV.3'
  },
  {
    level: 'LEVEL_40',
    name: 'LV.4'
  },
  {
    level: 'LEVEL_50',
    name: 'LV.5'
  },
  {
    level: 'LEVEL_60',
    name: 'LV.6'
  },
  {
    level: 'LEVEL_70',
    name: 'LV.7'
  },
  {
    level: 'LEVEL_80',
    name: 'LV.8'
  },
  {
    level: 'LEVEL_90',
    name: 'LV.9'
  },
  {
    level: 'LEVEL_100',
    name: 'LV.10'
  },
  {
    level: 'LEVEL_110',
    name: 'LV.11'
  },
  {
    level: 'LEVEL_120',
    name: 'LV.12'
  },
  {
    level: 'LEVEL_130',
    name: 'LV.13'
  },
  {
    level: 'LEVEL_140',
    name: 'LV.14'
  },
  {
    level: 'LEVEL_150',
    name: 'LV.15'
  },
  {
    level: 'LEVEL_160',
    name: 'LV.16'
  },
  {
    level: 'LEVEL_170',
    name: 'LV.17'
  },
  {
    level: 'LEVEL_180',
    name: 'LV.18'
  },
  {
    level: 'LEVEL_190',
    name: 'LV.19'
  },
  {
    level: 'LEVEL_200',
    name: 'LV.20'
  }
]

/**
 * MerchantDistLevelEditRequest
 */
export interface IMerchantDistLevelEditRequest {
  /**
   * 客服等级
   */
  csLevel?: CSLevel
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 用户等级
   */
  userLevelList?: string[]
}

/**
 * void
 *
 * Response«List«MerchantDistLevelResponse»»
 */
export interface IMerchantDistLevelResponseListParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: MerchantDistLevelResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * MerchantDistLevelResponse
 */
export interface MerchantDistLevelResponse {
  /**
   * 客服等级
   */
  csLevel?: CSLevel
  /**
   * 用户等级
   */
  userLevelList?: UserLevelList[]
}

/**
 * MerchantDistSwitchRequest
 */
export interface IMerchantDistSwitchRequest {
  /**
   * 开关值
   */
  enable?: boolean
  /**
   * 商户ID
   */
  merchantId?: string
}

export interface UserEmployeePageRequest {
  /**
   * 页数；例如：1
   */
  pageNum?: number
  /**
   * 每页条数；例如：10
   */
  pageSize?: number
  merchantId?: string
}

/**
 * MerchantDistPageUserRuleRequest
 */
export interface UserEmployeeCsTagInfoRequest {
  id: number // 主键id
  tagName: string // 标签名称
  tagRemark: string // 描述(自动生成)
  employeeCsName: string // 客服
  priority: number // 优先级
  status: boolean // 状态
  merchantId: number // 充值
  rechargeStart: number // 充值
  rechargeEnd: number // 充值
  profitStart: number // 盈亏
  profitEnd: number // 盈亏
  scoresStart: number // 总下粉
  scoresEnd: number // 总下分
  budgetStart: number // 流水
  budgetEnd: number // 流水
  rechargeMoneyStart: number // 流水
  rechargeMoneyEnd: number // 流水
  userList: EmployeeCsTag[]
}
export interface EmployeeCsTag {
  id: number // 主键
  employeeId: number // 客服主键
  tagId: number // 标签主键
  employeeName: string // 客服名称
}
/**
 * MerchantDistPageUserRuleRequest
 */
export interface IMerchantDistPageUserRuleRequest {
  /**
   * 坐席名称（模糊检索）
   */
  employeeName?: string
  /**
   * 坐席短ID
   */
  employeeShortId?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 页数；例如：1
   */
  pageNo?: number
  /**
   * 每页条数；例如：10
   */
  pageSize?: number
  /**
   * 用户ID
   */
  userId?: number
  /**
   * 用户昵称（模糊检索）
   */
  userNickName?: string
}

/**
 * void
 *
 * Response«PageResponse«MerchantDistUserResponse»»
 */
export interface IPageMerchantDistUserResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: PageResponseMerchantDistUserResponse
  /**
   * 请求返回消息
   */
  msg?: string
}

export interface IPageEployeeRespone {
  id: number // 主键id
  tagName: string // 标签名称
  tagRemark: string // 描述(自动生成)
  employeeCsName: string // 客服
  priority: number // 优先级
  status: boolean // 状态
  createBy: number // 创建人
  createTime: Date // 创建时间
  updateBy: number // 更新人
  updateTime: Date // 更新时间
  rechargeStart: number // 充值
  rechargeEnd: number // 充值
  profitStart: number // 盈亏
  profitEnd: number // 盈亏
  scoresStart: number // 总下粉
  scoresEnd: number // 总下分
  budgetStart: number // 流水
  budgetEnd: number // 流水
  rechargeMoneyStart: number // 流水
  rechargeMoneyEnd: number // 流水
}

export interface IPageEmployeeRespone {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: IPageEployeeRespone
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * 请求返回数据
 *
 * PageResponse«MerchantDistUserResponse»
 */
export interface PageResponseMerchantDistUserResponse {
  /**
   * 当前页数据列表
   */
  dataList?: MerchantDistUserResponse[]
  /**
   * 页数
   */
  pageNo?: number
  /**
   * 每页条数
   */
  pageSize?: number
  /**
   * 总条数
   */
  total?: number
}

/**
 * MerchantDistUserResponse
 */
export interface MerchantDistUserResponse {
  /**
   * 客服员工ID
   */
  employeeId?: number
  /**
   * 客服员工姓名
   */
  employeeName?: string
  /**
   * 客服员工短ID
   */
  employeeShortId?: number
  /**
   * 关联主键ID
   */
  id?: number
  /**
   * 用户Id
   */
  userId?: number
  /**
   * 用户昵称
   */
  userNickName?: string
}

/**
 * MerchantDistUserAddRequest
 */
export interface IMerchantDistUserAddRequest {
  /**
   * 客服员工短ID
   */
  employeeShortId?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 用户Id
   */
  userId?: number
}
/**
 * MerchantDistUserListAddRequest
 */
export interface IMerchantDistUserListAddRequest {
  userRulesList?: Array<IMerchantDistUserAddRequest>
}

/**
 * MerchantDistSwitchRequest
 */
export interface IMerchantDistSwitchRequest {
  /**
   * 开关值
   */
  enable?: boolean
  /**
   * 商户ID
   */
  merchantId?: string
}

export interface IBaseItem {
  id: string
  label: string
  value: string
}

// -------------------------------- 应用相关 ------------------------------------------------------

/**
 * 应用列表
 */
export function gameList(param: IGameListRequestParam): Promise<ResWrap<IGameListResponseParam>> {
  return service.post(`${gameInModule.gameListApi}`, param)
}

export function gameListByTenant(
  param: IGameListRequestParam
): Promise<ResWrap<IGameListResponseParam>> {
  return service.post(`${gameInModule.gameListByTenantApi}`, param)
}
export function gameUpdateTicketSwitch(param: any): Promise<ResWrap<any>> {
  return service.post(`${gameInModule.gameUpdateTicketSwitchApi}`, param)
}

/**
 * 应用列表
 */
export function allMerChantForSet(
  param: IGameListRequestParam
): Promise<ResWrap<IGameListResponseParam>> {
  return service.post(`${gameInModule.allMerChantForSet}`, param)
}

/**
 * 平台应用增加
 */
export function gameAdd(param: IMerchantAddRequestParam): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.gameAddApi}`, param)
}

/**
 * 平台删除
 */
export function gameDel(param: IdRequestParam): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.gameDelApi}`, param)
}

/**
 * 平台更新
 */
export function gameEdit(param: IMerchantEditRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.gameUpdateApi}`, param)
}

/**
 * 平台详情
 */
export function gameDetail(param: IdRequestParam): Promise<IGameDetailResponseParam> {
  return service.post(`${gameInModule.gameDetailApi}`, param)
}

//----------------------------------- 平台分配规则 模块 ------------------------------------------------

/**
 * 查看等级分配规则
 * ID：平台（应用id）
 * 客服等级对应
 */
export function queryDistributionRuleList(
  param: IdRequestParam
): Promise<IMerchantDistLevelResponseParam> {
  return service.post(`${gameInModule.distributionLevelRuleListApi}`, param)
}

/**
 * 编辑等级分配规则
 * @param param
 */
export function editDistributionRule(
  param: IMerchantDistLevelEditRequest
): Promise<IMerchantDistLevelResponseListParam> {
  return service.post(`${gameInModule.distributionLevelRuleEditApi}`, param)
}

/**
 * 开关等级分配规则
 * @param param
 */
export function switchLevelRule(param: IMerchantDistSwitchRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.switchLevelRuleApi}`, param)
}

/**
 * 查看用户分配规则
 * @param param
 */
export function queryPageUserRule(
  param: IMerchantDistPageUserRuleRequest
): Promise<IPageMerchantDistUserResponseParam> {
  return service.post(`${gameInModule.pageUserRuleApi}`, param)
}

export function addUserTag(param: UserEmployeeCsTagInfoRequest): Promise<IPageEmployeeRespone> {
  return service.post(`${gameInModule.userEmployeeCsTagInfoAdd}`, param)
}

export function getTagPage(param: UserEmployeePageRequest): Promise<IPageEmployeeRespone> {
  return service.post(`${gameInModule.userEmployeeCsTagInfoList}`, param)
}

/**
 * 删除用户分配规则
 */
export function getTagById(param: any): Promise<ResWrap<null>> {
  return service.get(`${gameInModule.getTagById}/${param}`)
}

export function deleteById(param: any): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.deleteById}/${param}`)
}

/**
 * 删除用户分配规则
 */
export function delUserRuleDistribution(param: IdRequestParam): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.delUserRuleApi}`, param)
}

/**
 * 新增用户分配规则
 * @param param
 */
export function addUserRuleDistribution(
  param: IMerchantDistUserAddRequest
): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.addUserRuleApi}`, param)
}
/**
 * 新增用户列表分配规则
 * @param param
 */
export function addUserListRuleDistribution(
  param: IMerchantDistUserListAddRequest
): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.addUserListRuleApi}`, param)
}

/**
 * 开关用户分配规则
 *
 * @param param
 */
export function switchUserRule(param: IMerchantDistSwitchRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.switchUserRule}`, param)
}
/**
 * 标签开关
 *
 * @param param
 */
export function switchTagRule(param: IMerchantDistSwitchRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.switchTagRuleApi}`, param)
}
/**
 * 标签列表状态修改
 *
 * @param param
 */
export function tagUpdateStatus(param: IMerchantDistSwitchRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.tagUpdateStatusApi}`, param)
}

/**
 * 标签列表优先级修改
 *
 * @param param
 */
export function tagUpdateSort(param: IMerchantDistSwitchRequest): Promise<ResWrap<null>> {
  return service.post(`${gameInModule.tagUpdateSortApi}`, param)
}

//----------------------------------- 方法 ----------------------------------

/**
 * 初始化用户数据
 */
export function initLevelData() {
  return [
    {
      csLevel: CSLevel.Level10,
      userLevelList: []
    },
    {
      csLevel: CSLevel.Level20,
      userLevelList: []
    },
    {
      csLevel: CSLevel.Level30,
      userLevelList: []
    }
  ]
}

export const csLevelList: IBaseItem[] = [
  {
    id: 'LEVEL_10',
    label: t('GAME.primary'),
    value: CSLevel.Level10
  },
  {
    id: CSLevel.Level20,
    label: t('GAME.intermediate'),
    value: CSLevel.Level20
  },
  {
    id: CSLevel.Level30,
    label: t('GAME.advanced'),
    value: CSLevel.Level30
  }
]

export const userLevelList: IBaseItem[] = [
  {
    id: UserLevelList.Level0,
    label: 'VIP0',
    value: UserLevelList.Level0
  },
  {
    id: UserLevelList.Level10,
    label: 'VIP1',
    value: UserLevelList.Level10
  },
  {
    id: UserLevelList.Level20,
    label: 'VIP2',
    value: UserLevelList.Level20
  },
  {
    id: UserLevelList.Level30,
    label: 'VIP3',
    value: UserLevelList.Level30
  },
  {
    id: UserLevelList.Level40,
    label: 'VIP4',
    value: UserLevelList.Level40
  },
  {
    id: UserLevelList.Level50,
    label: 'VIP5',
    value: UserLevelList.Level50
  },
  {
    id: UserLevelList.Level60,
    label: 'VIP6',
    value: UserLevelList.Level60
  },
  {
    id: UserLevelList.Level70,
    label: 'VIP7',
    value: UserLevelList.Level70
  },
  {
    id: UserLevelList.Level80,
    label: 'VIP8',
    value: UserLevelList.Level80
  },
  {
    id: UserLevelList.Level90,
    label: 'VIP9',
    value: UserLevelList.Level90
  },
  {
    id: UserLevelList.Level100,
    label: 'VIP10',
    value: UserLevelList.Level100
  },
  {
    id: UserLevelList.Level110,
    label: 'VIP11',
    value: UserLevelList.Level110
  },
  {
    id: UserLevelList.Level120,
    label: 'VIP12',
    value: UserLevelList.Level120
  },
  {
    id: UserLevelList.Level130,
    label: 'VIP13',
    value: UserLevelList.Level130
  },
  {
    id: UserLevelList.Level140,
    label: 'VIP14',
    value: UserLevelList.Level140
  },
  {
    id: UserLevelList.Level150,
    label: 'VIP15',
    value: UserLevelList.Level150
  },
  {
    id: UserLevelList.Level160,
    label: 'VIP16',
    value: UserLevelList.Level160
  },
  {
    id: UserLevelList.Level170,
    label: 'VIP17',
    value: UserLevelList.Level170
  },
  {
    id: UserLevelList.Level180,
    label: 'VIP18',
    value: UserLevelList.Level180
  },
  {
    id: UserLevelList.Level190,
    label: 'VIP19',
    value: UserLevelList.Level190
  },
  {
    id: UserLevelList.Level200,
    label: 'VIP20',
    value: UserLevelList.Level200
  }
]

export function formatCs(val: string): string {
  if (val == CSLevel.Level10) {
    return t('GAME.primary')
  } else if (val == CSLevel.Level20) {
    return t('GAME.intermediate')
  } else if (val == CSLevel.Level30) {
    return t('GAME.advanced')
  } else {
    return t('BUSINESS.unkonwn')
  }
}

export function formatUser(val: string): string {
  const arr = userLevelList.filter((item) => item.value == val)
  if (arr && arr.length > 0) {
    return arr[0].label
  }
  return ''
}

/**
 * 返回item操作
 */
export function formatUserList(arr: string[]): IBaseItem[] {
  const arrReturn: IBaseItem[] = []
  if (arr && arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      userLevelList.forEach((item) => {
        if (arr[i] == item.value) {
          arrReturn.push(item)
        }
      })
    }
  }

  return arrReturn
}
export function addProblem(param: any): Promise<any> {
  return service.post(`${gameInModule.addProblemApi}`, param)
}
export function editProblem(param: any): Promise<any> {
  return service.post(`${gameInModule.editProblemApi}`, param)
}

export function listProblem(param: any): Promise<any> {
  return service.post(`${gameInModule.listProblemApi}`, param)
}

export function delProblem(param: any): Promise<any> {
  return service.post(`${gameInModule.delProblemApi}`, param)
}

// 修改常见问题开关
export function updateProblemSwitch(param: any): Promise<any> {
  return service.post(`${gameInModule.updateProblemSwitchApi}`, param)
}

// 根据商户id查当前常见问题开关
export function getProblemStatus(param: any): Promise<any> {
  return service.post(`${gameInModule.getProblemStatusApi}`, param)
}
